<template>
  <div class="product-detail-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background">
        <img :src="Images.products.background_2" alt="Background" class="hero-bg-image">
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <h1 class="hero-title">产品系列</h1>
        <div class="hero-subtitle-container">
          <img :src="Images.products.left" alt="left bar" class="hero-subtitle-line">
          <span class="hero-subtitle">PRODUCT SERIES</span>
          <img :src="Images.products.right" alt="right bar" class="hero-subtitle-line">
        </div>
      </div>
    </section>
    
    <!-- Breadcrumb Navigation -->
    <section class="breadcrumb-section">
      <div class="container">
        <nav class="breadcrumb">
          <router-link to="/home" class="breadcrumb-item">首页</router-link>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item active">产品与服务</span>
        </nav>
      </div>
    </section>
    
    <!-- All Product Details -->
    <section class="all-products-section">
      <div class="container2">
        <div class="all-products-grid">
          <div v-for="product in products" :key="product.id" class="product-item">
            <div class="product-content" :class="{'image-left': product.id % 2 === 1, 'image-right': product.id % 2 === 0}">
              <!-- Product Image -->
              <div class="product-image-container">
                <img :src="product.image" :alt="product.title" class="product-image">
              </div>
              <!-- Product Details -->
              <div class="product-details">
                <h2 class="product-title">{{ product.title }}</h2>
                <div class="product-divider"></div>
                
                <div class="product-features">
                  <div v-for="(feature, index) in product.features" :key="index" class="feature-item">
                    <p class="feature-text" v-html="boldKeywords(feature)"></p>
                  </div>
                </div>
                
                <div class="product-applicable">
                  <p class="applicable-text" v-html="boldKeywords(product.applicable)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'ProductDetailView',
  data() {
    return {
      products: [
        {
          id: 1,
          title: 'AI耳机',
          image: Images.products.product_1,
          features: [
            '场景降噪：通过 AI 算法实时识别环境 ，自动调节降噪 / 通透模式，不用手动切换；',
            '音质优化：根据你的听歌偏好（摇滚 / 古典 / 人声），智能调校音效，定制专属听觉体验；',
            '通话增强：AI 识别通话背景噪音，精准放大你的人声，嘈杂环境也能 “清” 松通话。'
          ],
          applicable: '适用场景：通勤、办公、运动'
        },
        {
          id: 2,
          title: 'AI 智能音箱',
          image: Images.products.product_3,
          features: [
            '场景降噪：通过 AI 算法实时识别环境噪音（电视声 / 环境杂音），自动增强人声拾取、抑制干扰，远场也能精准响应指令；',
            '内容适配：根据你的收听偏好（音乐 / 有声书 / 新闻），智能推荐相似内容，还能记住常听节目自动续播；',
            '语音交互：AI 精准识别多轮对话与复杂指令，支持打断回应，多人交流时也能精准定位说话人。'
          ],
          applicable: '适用场景：居家休闲、智能家居控制、亲子互动'
        },
        {
          id: 3,
          title: 'AI 眼镜',
          image: Images.products.product_2,
          features: [
            '实时翻译：通过 AI 算法识别多语种语音，毫秒级转写为字幕投射在镜片，跨国沟通无需低头看屏；',
            '场景适配：根据环境光线自动调节字幕亮度，户外强光 / 室内弱光下都能清晰查看，不影响正常视物；',
            '语音助手：AI 识别语音指令，快速查询导航、天气、日程，解放双手无需操作手机。'
          ],
          applicable: '适用场景：跨境出行、商务洽谈、外语交流'
        },

        {
          id: 4,
          title: 'AI桌面机器人',
          image: Images.products.product_4,
          features: [
            '情绪感知：通过 AI 算法捕捉面部表情与语音语调，识别疲惫 / 焦躁状态，主动提供安抚互动或专注陪伴；',
            '办公协同：根据你的工作习惯，智能整理邮件要点、安排会议日程，同步电脑与日历信息；',
            '专注管理：AI 监测专注时长，自动触发番茄工作法（专注 / 休息循环），避免分心提升效率；'
          ],
          applicable: '适用场景：办公桌面、居家学习、远程工作'
        },
        {
          id: 5,
          title: 'AI 录音卡片',
          image: Images.products.product_5,
          features: [
            '降噪录音：通过 AI 算法过滤环境杂音（空调声 / 背景人声），精准收录核心语音，录音更清晰纯净；',
            '智能转写：实时将语音转写为文字，自动区分讲话人、修正识别误差，支持多语种转写；',
            '要点总结：AI 提取录音关键信息（待办 / 决策 / 核心观点），自动生成结构化摘要，无需逐字整理；'
          ],
          applicable: '适用场景：会议记录、课程学习、访谈调研'
        },
        {
          id: 6,
          title: 'AI 智能闹钟',
          image: Images.products.product_6,
          features: [
            '睡眠适配：通过 AI 算法监测睡眠状态（深睡 / 浅睡），在浅睡期启动渐亮灯光 + 轻柔铃声，温柔唤醒不扰眠；',
            '日程联动：根据你的闹钟时间与日程安排，智能提醒出行事项（堵车预警 / 天气适配），合理规划出门时间；',
            '学习辅助：AI 支持拼音跟读、古诗解析、英语口语纠音，唤醒后可开启碎片化学习；'
          ],
          applicable: '适用场景：家庭、办公、学习'
        }
      ]
    }
  },
  computed: {
    Images() {
      return Images;
    }
  },
  
  methods: {
    // 加粗指定关键词
    boldKeywords(text) {
      const keywords = ['场景降噪', '音质优化', '通话增强', '适用场景'];
      let result = text;
      keywords.forEach(keyword => {
        const regex = new RegExp(`(${keyword})`, 'g');
        result = result.replace(regex, '<strong>$1</strong>');
      });
      return result;
    }
  },
  
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: 72.5vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  margin-top: 80px;
  padding-top: 260px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.hero-content {
  text-align: left;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 80px;
  margin-left: 290px;
  margin-top: 100px;
}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  line-height: 1.2;
}

.hero-subtitle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
}

.hero-subtitle-line {
  width: 60px;
  height: 2px;
  object-fit: contain;
}

.hero-subtitle {
  font-size: 18px;
  letter-spacing: 4px;
  white-space: nowrap;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* Breadcrumb Navigation */
.breadcrumb-section {
  padding: 20px 0;
  /* background-color: #f8f8f8; */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}

.breadcrumb-separator {
  margin: 0 10px;
  color: #ccc;
}

.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}

/* All Products Section */
.all-products-section {
  padding: 80px 0;
  background-color: white;
}

.container2 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.all-products-grid {
  display: flex;
  flex-direction: column;
  gap: 80px;
  margin-top: 60px;
}

.product-item {
  width: 100%;
}

.product-content {
  display: flex;
  align-items: center;
  gap: 80px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 图片左文字右 */
.product-content.image-left {
  flex-direction: row;
}

/* 图片右文字左 */
.product-content.image-right {
  flex-direction: row-reverse;
}

/* Product Image */
.product-image-container {
  flex: 0 0 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background-color: white;
  border: 1px dashed #ccc;
}

.product-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Product Details */
.product-details {
  flex: 0 0 500px;
  padding-top: 0;
}

.product-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.product-divider {
  width: 60px;
  height: 3px;
  background-color: #ff6b00;
  margin-bottom: 30px;
}

.product-features {
  margin-bottom: 30px;
}

.feature-item {
  margin-bottom: 20px;
}

.feature-text {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin: 0;
}

.product-applicable {
  padding-top: 0;
  border-top: none;
}

.applicable-text {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin: 0;
}

/* 加粗关键词样式 */
.feature-text strong,
.applicable-text strong {
  font-weight: bold;
  color: #000;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }
  
  .product-info-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .product-image-container,
  .product-details {
    flex: 0 0 100%;
  }
}
</style>